import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePositionTab } from '../../drawer-container/hooks/use-position-tab';
import styles from '../font-drawer.module.scss';
import { ObjectOrder } from './object-order';
import { CUIText } from '@dotcom/crown-ui';

export const PositionTab = (): React.ReactElement => {
  const { t } = useTranslation();
  const { handleBringToFrontClick, handleSendToBackClick } = usePositionTab();

  return (
    <div data-testid="position-tab">
      <div className={styles['position-text-layer-label']}>
        <CUIText as="label" variant="form" htmlFor="" style={{ paddingLeft: 0 }}>
          {t('fontDrawer.positionTextLayer')}
        </CUIText>
        <ObjectOrder
          onBringToFront={handleBringToFrontClick}
          onSendToBack={handleSendToBackClick}
          bringToFrontLabel={t('fontDrawer.bringToFront')}
          sendToBackLabel={t('fontDrawer.sendToBack')}
        />
      </div>
    </div>
  );
};
